import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='13' height='11' viewBox='0 0 13 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.06367 10.2513C3.85563 10.2513 3.64759 10.1717 3.48831 10.014L0.237701 6.76344C-0.0792336 6.4465 -0.0792336 5.93128 0.237701 5.61435C0.554635 5.29741 1.06986 5.29741 1.38679 5.61435L4.06204 8.2896L11.6132 0.738433C11.9301 0.421499 12.4454 0.421499 12.7623 0.738433C13.0792 1.05537 13.0792 1.57059 12.7623 1.88752L4.63578 10.014C4.4765 10.1733 4.26846 10.2513 4.06042 10.2513H4.06367Z'
      fill='white'
    />
  </svg>
)
